import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const EXISTING_PATIENT_MSG = "Pasien dengan nomor ini sudah terdaftar di database klinik. Data pasien yang ada akan digunakan.";

// Real-time lookup: returns the existing clinic patient for a phone number (debounced).
export function usePhoneCheck(phone, enabled = true) {
  const [existing, setExisting] = useState(null);
  const [checking, setChecking] = useState(false);
  useEffect(() => {
    const digits = String(phone || "").replace(/\D/g, "");
    if (!enabled || digits.length < 9) { setExisting(null); return; }
    setChecking(true);
    const t = setTimeout(() => {
      api.get("/patients/check-phone", { params: { phone } })
        .then((r) => setExisting(r.data.exists ? r.data.patient : null))
        .catch(() => setExisting(null))
        .finally(() => setChecking(false));
    }, 400);
    return () => clearTimeout(t);
  }, [phone, enabled]);
  return { existing, checking };
}
